
import _axiosInstance from "../../interceptor/_axiosInstance";
import axiosInstance from "../../interceptor/axiosInstance";
import { LocalStorage } from "../../shared/utils/LocalStorageHelpers";

import { META_URL } from "../../routes/routeConstants/apiRoutes";
import { deserialize } from "serializr";


import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
import { BoardModel } from "../../models/CourseModels/BoardModel/board.model";
import { BoardMetaModel } from "../../models/TutorModel/tutor.model";
import { Branches } from "../../models/InstituteModel/branches.model";
import { Institutes } from "../../models/InstituteModel/institutes.model";
import { ClassroomModel } from "../../models/CourseModels/ClassroomModel/classroom.model";
import { Sections } from "../../models/InstituteModel/sections.model";
import { SectionSubjects } from "../../models/LeaderboardModel/Leaderboard.model";
import ChaptorModel from "../../models/ChaptorModel/Chaptor.model";

import { BOARDS_MASTER, GRADE_MASTER_BY_BOARD, BRANCHES_MASTER, INSTITUTES_MASTER, GRADE_MASTER, SECTIONS_MASTER, SUBJECTS_MASTER, CHAPTERS_MASTER } from "../../routes/routeConstants/apiRoutes";



export default class CommonService {
    static fetchMeta(
        metaName: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(META_URL + `/${metaName}`)
            .then(response => {

                const meta: any = deserialize(MetaModel, response.data[metaName]);
                // const options = response.data[metaName].map((option: any) => ({
                //     label: option.name,
                //     value: option.id
                // }))
                onSuccess(meta);
            })
            .catch(error => {
                onError(error);
            })
            .finally(onFinal)
    }

    static fetchTreeMeta(
        metaName: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(META_URL + `/${metaName}`)
            .then(response => {
                const meta: any = deserialize(BoardMetaModel, response.data[metaName]);
                const options = meta.map((board: any) => ({
                    title: board.acronym,
                    value: board.id,
                    key: board.id,
                    type: 'board',
                    children: board.classrooms.map((classroom: any) => ({
                        title: classroom.name,
                        value: board.id + '-' + classroom.id,
                        key: board.id + '-' + classroom.id,
                        type: 'classroom',
                        children: classroom.classroomSubjects.map((classroomSubject: any) => ({
                            title: classroomSubject.name,
                            value: board.id + '-' + classroom.id + '-' + classroomSubject.id,
                            key: board.id + '-' + classroom.id + '-' + classroomSubject.id,
                            type: 'subject',
                        }))
                    }))
                }))
                onSuccess(options);
            })
            .catch(error => {
                onError(error);
            })
            .finally(onFinal)
    }

    // Filter
    static fetchInstitutesMeta(
        onSuccess: (value: Institutes[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(INSTITUTES_MASTER)
            .then(response => {
                let data = deserialize(Institutes, response["data"])
                const user = LocalStorage.getItem("USER")
                let FilterData = data as Institutes[]
                if (user?.roleName === 'instituteadmin')
                    FilterData = FilterData.filter(inst => inst?.id === user?.instituteId)
                onSuccess(FilterData)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
    static fetchBoardsMeta(
        onSuccess: (value: BoardModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(BOARDS_MASTER)
            .then(response => {
                const data = deserialize(BoardModel, response["data"])
                onSuccess(data as BoardModel[])
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    static fetchBranchesMeta(
        instituteId: number,
        onSuccess: (value: Branches[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(BRANCHES_MASTER, {
            params: {
                InstId: instituteId
            }
        })
            .then(response => {
                const data = deserialize(Branches, response["data"])
                onSuccess(data as Branches[])
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    static fetchGradeMeta(
        branchId: number,
        onSuccess: (value: ClassroomModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(GRADE_MASTER, {
            params: {
                BranchId: branchId,
            },
        })
            .then((response) => {
                const data = deserialize(
                    ClassroomModel,
                    response?.data
                ) as ClassroomModel[];
                onSuccess(data);
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }

    static fetchGradeMetaByBoard(
        BoardId: number | string,
        onSuccess: (value: ClassroomModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(GRADE_MASTER_BY_BOARD, {
            params: {
                BoardId: BoardId,
            },
        })
            .then((response) => {
                const data = deserialize(
                    ClassroomModel,
                    response?.data
                ) as ClassroomModel[];
                onSuccess(data);
            })
            .catch((e) => {
                onError(e);
            })
            .finally(onFinal);
    }

    static fetchSectionsMeta(
        params: any,
        onSuccess: (value: Sections[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(SECTIONS_MASTER, { params })
            .then((response) => {
                const sections = deserialize(
                    Sections,
                    response.data
                ) as Sections[];
                onSuccess(sections);
            })
            .catch((error) => {
                onError(error);
            })
            .finally(onFinal);
    }

    static fetchSubjectsMeta(
        classId: number,
        onSuccess: (value: SectionSubjects[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance.get(SUBJECTS_MASTER, {
            params: {
                ClassId: classId
            }
        })
            .then(response => {
                const data = deserialize(SectionSubjects, response["data"]) as SectionSubjects[]
                onSuccess(data)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
    static fetchChaptersMeta(
        params: any,
        onSuccess: (value: ChaptorModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return _axiosInstance
            .get(CHAPTERS_MASTER, { params })
            .then(response => {
                const data = deserialize(ChaptorModel, response.data) as ChaptorModel[]
                onSuccess(data)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
}


